import metas from 'locales/metas.json';
import {getCurrentUrl} from '@app/modules/location';
import nextI18nextConfig from 'next-i18next.config';

type LanguageAlternate = {
	hrefLang: string;
	href: string;
};
export const getSEOLocaleMetas = (
	pathname: string,
	seoLocales = metas.availableLanguages,
): LanguageAlternate[] => {
	const filteredLocales = seoLocales?.filter(
		(lang) => !metas.sunsetLanguages.includes(lang),
	);
	if (filteredLocales.length === 0) {
		throw new Error('Cannot have no opened locales');
	}
	return [
		{
			hrefLang: 'x-default',
			href: filteredLocales.includes(nextI18nextConfig.i18n.defaultLocale)
				? getCurrentUrl({locale: null, pathname})
				: getCurrentUrl({locale: filteredLocales[0], pathname}),
		},
		...filteredLocales.map((locale) => ({
			href: getCurrentUrl({locale, pathname}),
			hrefLang: locale,
		})),
	];
};
